import React from "react";
import classNames from "classnames";

export default class Panel extends React.Component {
  render() {
    const { className, splitted, title, ...rest } = this.props;
    const panelClasses = classNames(
      className,
      "panel",
      splitted ? "panel--splitted" : ""
    );

    return (
      <div className={ panelClasses } { ...rest }>
        { title ? <span className="panel__title"> { title } </span> : null }
        <div className="panel__inner">
          { this.props.children }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./app/components/Panel/Panel.jsx